const initials = "bestSeller/";
export const UPDATE_BEST_SELLER_PRODUCTS = `${initials}UPDATE_BEST_SELLER_PRODUCTS`;
